import React from "react";
import { connect } from "react-redux";
import { changeEtapas } from "../actions";
import { scrollElementToTop } from "../functions";

class FinalizarMiPlanMovilidad extends React.PureComponent {

  componentDidMount = () => {
    scrollElementToTop("finalizar-configuracion-plan-movilidad");
  }

  render() {
    return (
      <section id="finalizar-configuracion-plan-movilidad">
        <div className="container-fluid">
          <div className="row PM-plan-borde-spacing">
            <div className="position-relative overflow-hidden p-3 p-md-5 m-md-3 text-center">
              <div className="col-md-8 p-lg-5 mx-auto my-5 cuadro-1">
                <div className="row col-md-12 PM-tipo-denuncias-select PM-plan-exito">
                  <div className="col-md-12 text-center">
                    <span className="PM-felicita"><strong>¡Felicitaciones!</strong></span>
                  </div>
                  <div className="col-md-12 text-center PM-section-title">Finalizaste la etapa de definición del plan de movilidad.</div>
                  <div className="col-md-12 text-center PM-info">
                    <p>Ahora hay que transformarlo en realidad. En la siguiente etapa encontrarás todo el material para apoyar la implementación de las acciones definidas para tu centro de trabajo.</p>
                  </div>
                </div>
                <div className="PM-home-item_plan PM-plan-contador-finalizar">
                  <button
                    className="btn PM-dx-button-plan PM-dx-button-plan-100"
                    onClick={() => {
                      this.props.dispatch(changeEtapas(3));
                    }}
                  >Continuar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="PM-footer">&nbsp;</div>
      </section>
    );
  }
}

const mapStateToProps = () => ({
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(FinalizarMiPlanMovilidad);
